<template>
  <div class="seat-state-wrapper">
    <div v-for="data in floorPlanStats" :key="data.label" class="seat-state">
      <div class="state-logo" :style="data.style" />
      <span>{{ data.label }}</span>
      <p class="count">{{ data.count() }}</p>
    </div>
  </div>
</template>
<script>
import { SeatState } from '@/types'
import { isEmpty } from 'lodash'

export default {
  name: 'floor-plan-stats',
  props: {
    allOrderItems: {
      type: Array,
      default: () => [],
    },
    initVenueAvailability: {
      type: Object,
      default: () => null,
    },
    selectedSeats: {
      type: Array,
      default: () => [],
    },
    venueSeatIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      SeatState: SeatState,
    }
  },
  computed: {
    floorPlanStats() {
      return [
        {
          label: 'Free',
          count: () => {
            if(!this.initVenueAvailability) return 0

            return this.venueSeatIds.filter(id => {
              return (
                !this.initVenueAvailability[id] ||
                this.initVenueAvailability[id].state === SeatState.DISABLED
              )
            }).length
          },
          style: 'background: var(--Grey-40, rgb(217, 217, 217))',
        },
        {
          label: 'Marked',
          count: () => {
            if(!this.initVenueAvailability) return 0

            return Object.values(this.initVenueAvailability).filter(
              seat => seat.state === SeatState.AVAILABLE,
            ).length
          },
          style:
            'background: conic-gradient(from 180deg at 50% 50%, #F00 0deg, #FFC700 48.60000193119049deg, #05FF00 109.80000257492065deg, #0FF 174.6000051498413deg, #0AF 226.79999828338623deg, #5D00FF 282.60000944137573deg, #FF00C7 360deg);',
        },
        {
          label: 'Selected',
          count: () => {
            return this.selectedSeats.length
          },
          style: 'background: var(--Grey-40, #F5F5F5);border: 3px solid var(--Grey-30, #333);',
        },
        {
          label: 'Two tickets added',
          count: () => {
            let count = 0
            this.venueSeatIds.forEach(
              id => this.allOrderItems.filter(oi => oi.sectionSeats.includes(id)).length > 1 && count++
            )

            return count
          },
          style: 'background: var(--Grey-00, #333);border:1px solid var(--Grey-30, #D9D9D9);',
        },
        {
          label: 'Booked/Sold',
          count: () => {
            if(!this.initVenueAvailability) return 0

            return Object.values(this.initVenueAvailability).filter(
              seat => seat.state === SeatState.SOLD || seat.state === SeatState.HOLD,
            ).length
          },
          style: 'background: var(--Grey-40, #F5F5F5);border: 1px solid var(--Grey-30, #D9D9D9);',
        },
        {
          label: 'Unavailable',
          count: () => {
            if(!this.initVenueAvailability) return 0

            return Object.values(this.initVenueAvailability).filter(
              seat => seat.state === SeatState.DISABLED || isEmpty(seat),
            ).length
          },
          style: 'background: #D9D9D9;',
        },
      ]
    },
  },
}
</script>

<style scoped>
.seat-state-wrapper {
  width: fit-content;
  display: flex;
  border-top: 2px solid #f5f5f5;
  padding: 1rem;
  column-gap: 0.5rem;
  gap: 6px;
}
.state-logo {
  height: 1rem;
  width: 1rem;
  align-self: center;
  background: black;
  border-radius: 100rem;
}
span {
  color: var(--Grey-10, #666);
}
.seat-state {
  display: flex;
  align-items: flex-start;
  column-gap: 0.5rem;
  padding: 0.2rem 0.5rem;
}
.count {
  color: var(--Primary-10, #0277bd);
  display: flex;
  padding: 4px;
  margin: 0;
  align-items: center;
  gap: 8px;
  font-family: 'Source Sans Pro';
  font-size: 12px;
  font-style: normal;
  border-radius: 2px;
  background: var(--Primary-50, #f0f6fa);
  font-weight: 400;
  line-height: 150%; /* 18px */
}
</style>
